/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Description_P1Inputs */

const es_tyc_description_p1 = /** @type {(inputs: Tyc_Description_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata es una plataforma de conocimiento empresarial que proporciona herramientas para buscar, gestionar e interactuar con datos de fuentes conectadas, incluyendo pero no limitado a:`)
};

const en_tyc_description_p1 = /** @type {(inputs: Tyc_Description_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata is an enterprise knowledge platform that provides tools to search, manage, and interact with data from connected sources, including but not limited to:`)
};

/**
* | output |
* | --- |
* | "Nexata is an enterprise knowledge platform that provides tools to search, manage, and interact with data from connected sources, including but not limited to:" |
*
* @param {Tyc_Description_P1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_description_p1 = /** @type {((inputs?: Tyc_Description_P1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Description_P1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_description_p1(inputs)
	return en_tyc_description_p1(inputs)
});
export { tyc_description_p1 as "tyc.description.p1" }